<div class="loading-indicator">
    <mat-spinner class="loading-spinner" color="primary"></mat-spinner>
</div>